























import { defineComponent, reactive } from "@vue/composition-api";

import { ThemProfPropsDef, ThemProfProps } from "@/models";
import SectionDefault from "./section-default.vue";

export default defineComponent<ThemProfPropsDef>({
  name: "ContactMe",
  components: { SectionDefault },
  props: {
    ...ThemProfProps
  },

  //   setup(props: Props, context: SetupContext){
  setup(props: ThemProfPropsDef) {
    const state = reactive({
      sender: "",
      subject: "",
      body: ""
    });

    return { state };
  }
});
